/* eslint-disable */
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { formActions } from '../../../Actions';
import ListTable from '../../../Components/ListTable/ListTable';
import { BackdropLoader } from '../../../Components/Loaders';
import AlertModal from '@/Components/Modals/AlertModal/AlertModal';
import { modalActions } from '@/Actions';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';
import { urls } from '@/Constants';
import { Button } from '@/Components/ui/button';
import { useHistory, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { Pencil, Trash2 } from 'lucide-react';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/Components/ui/tooltip';

const TABLE_COLUMNS = [
	{
		title: 'Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Description',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Code',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [{
	title: 'Action',
	config: {
		type: 'DATA',
	},
}];

const COLMAP = {
	Name: 'name',
	Description: 'description',
	Category: 'categoryName',
	Code: 'code',
};

const ProductSubCategoryListPage = (props) => {
	const {
		fetchProductSubCategory,
		data,
		deleteProductSubCategory,
		query,
		navState,
		fetchUserList,
		userList,
		toggleAlert,
	} = props;

	const [isLoading, setIsLoading] = useState(false);
	const history = useHistory();
	const { url } = useRouteMatch();
	const { userConfig = {} } = useAuth();

	const fetchSubCategoryFunc = async () => {
		setIsLoading(true);
		await fetchProductSubCategory({
			entity: 'PRODUCT_SUB_CATEGORY',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		setIsLoading(false);
	};

	useEffect(() => {
		fetchSubCategoryFunc();
	}, []);

	const handleDelete = (id) => {
		toggleAlert(true, {
			message: 'Are you sure you want to delete this sub-category?',
			heading: 'Delete Sub-Category',
			confirmText: 'Delete',
			cancelText: 'Cancel',
			handleConfirm: () => {
				deleteProductSubCategory({
					entity: 'PRODUCT_SUB_CATEGORY',
					req: {
						params: {
							id,
						},
					},
					method: 'DELETE',
				});
				toggleAlert(false);
			},
		});
	};

	const handleEdit = (id) => {
		const route = `${url}/edit/${id}`;
		return history.push(route);
	};

	const SPECIAL_ITEMS = {
		Action: (id) => {
			return (
				<TooltipProvider>
					<div className='flex gap-2'>
						<Tooltip>
							<TooltipTrigger asChild>
								<Button
									variant='outline'
									size='icon'
									onClick={() => handleEdit(id)}
									className="h-8 w-8 bg-blue-50 text-blue-600 border-blue-200 hover:bg-blue-100 hover:text-blue-700 transition-colors"
								>
									<Pencil className="w-4 h-4" />
								</Button>
							</TooltipTrigger>
							<TooltipContent>
								<p>Edit Sub-Category</p>
							</TooltipContent>
						</Tooltip>
						<Tooltip>
							<TooltipTrigger asChild>
								<Button
									variant='outline'
									size='icon'
									onClick={() => handleDelete(id)}
									className="h-8 w-8 bg-red-50 text-red-600 border-red-200 hover:bg-red-100 hover:text-red-700 transition-colors"
								>
									<Trash2 className="w-4 h-4" />
								</Button>
							</TooltipTrigger>
							<TooltipContent>
								<p>Delete Sub-Category</p>
							</TooltipContent>
						</Tooltip>
					</div>
				</TooltipProvider>
			);
		},
	};
	// USER START
	// userAcess
	// useEffect(async () => {
	// 	fetchUserList();
	// }, []);
	// // function page role of user access

	// const map = new Map(userList.map((item) => [item.value, item.label]));
	// const role = Object.keys(userConfig?.userRoles);
	// const userRoles = [];
	// role.forEach((ele) => {
	// 	userRoles.push(ele);
	// });
	// const pageRole = navState['/products']?.submenu?.['/products/sub/category']?.rolesMapped;
	// const findMatchingRole = userRoles.filter((ele) => pageRole.includes(Number(ele)));
	// const roleDetails = findMatchingRole.map((role) => {
	// 	const key = Number(role);
	// 	const name = map.get(key);
	// 	return {
	// 		role: key, name,
	// 	};
	// });
	// const isInternal = roleDetails.some((item) => item.name === 'Internal' || item.name === 'CXO Office' || item.name === 'Production' || item.name === 'Procurement' || item.name === 'Distribution And Supply Chain');
	// const access = findMatchingRole.length > 0 ? userConfig?.userDetails?.level : false;
	// let permit;
	// if (access === false) {
	// 	permit = false;
	// } else {
	// 	permit = isInternal && access !== 1;
	// }
	// USER END

	return (
		<div className='list-page-root'>
			<BackdropLoader showProgress isLoading={isLoading} />
			<AlertModal />
			<ListTable
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				fixedHeaderTop={0}
				data={data
					.filter((category) => {
						return (
							category.name
								.toLowerCase()
								.indexOf(query?.trim()?.toLowerCase()) !== -1
						);
					})
					.map((category) => {
						return {
							...category,
							_name: category?.[COLMAP?.Name],
						};
					})}
				actions={[...SPECIAL_COLUMNS]}
				special={SPECIAL_ITEMS}
			/>
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.PRODUCT_SUB_CATEGORY.data.LIST;
	const { navState, userPermissions } = state.navigation;
	const { userList } = state.auth;
	return {
		data,
		navState,
		userPermissions,
		userList,
	};
};

const mapDispatchToProps = {
	fetchProductSubCategory: formActions.gateway,
	toggleDisableProductCategory: formActions.gateway,
	deleteProductSubCategory: formActions.gateway,
	fetchUserList: authActions?.fetchUserList,
	toggleAlert: modalActions.toggleAlert,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ProductSubCategoryListPage);
